import type { Dtos } from "@inrev/common";

export const LEGACY_NAICS_VERSION_YEAR = 2017;

export const naicsCodesQueryKey = (params: Dtos.NaicsCode.List.Request) =>
	["naics-codes", params.versionYear, params.kind, params.parentId] as const;
